import { useEffect, useState } from 'react';
import { ApiError } from '../../../lib/apiError';
import { vacanciesApi } from './vacanciesApi';
import type { RecruitmentUserOption } from './vacancyTypes';

/**
 * The live accounts the "Posted by" and "Screened by" pickers offer — one fetch per form. A failed
 * feed leaves the picker empty with the reason in its description, never a broken form.
 */
export function useRecruitmentUsers(
  /** Where the list comes from — Vacancies by default; Deliberate passes its own door, under its endorse key. */
  load: (signal: AbortSignal) => Promise<RecruitmentUserOption[]> = vacanciesApi.userOptions,
) {
  const [users, setUsers] = useState<RecruitmentUserOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    load(controller.signal)
      .then((loaded) => {
        setUsers(loaded);
        setLoading(false);
      })
      .catch((caught: unknown) => {
        if (caught instanceof DOMException && caught.name === 'AbortError') return;
        setLoading(false);
        setError(caught instanceof ApiError ? caught.message : 'The accounts could not be loaded.');
      });

    return () => controller.abort();
  }, [load]);

  return { users, loading, error };
}
